//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapGetters } from 'vuex';
import { set } from 'lodash';
export default {
  name: 'SidebarItem',
  props: {
    isNest: {
      type: Boolean,
      default: false,
    },
    menuList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      isClickMenu: false,
      threeMenu: {
        'layout-manage': { isClick: false },
        'new-metadata': { isClick: false },
        'iam-entry': { isClick: false },
        'meta-entry': { isClick: false },
        personnel_role: { isClick: false },
        'role-list': { isClick: false, redirect_from: 'personnel_role' },
        'component-management': { isClick: false },
      },
    };
  },

  computed: {
    routeList() {
      const list = [];
      this.$router.options.routes.forEach((route) => {
        if (route.name) {
          list.push(route.name);
        }
        if (route.children) {
          route.children.forEach((item) => {
            if (item.name) {
              list.push(item.name);
            }
          });
        }
      });
      return list;
    },
  },
  mounted() {
    Object.keys(this.threeMenu).forEach((key) => {
      console.log('--key---', key, this.$route.path);
      if (this.$route.path.indexOf(key) !== -1) {
        this.threeMenu[key].isClick = true;
        if (this.threeMenu[key]?.redirect_from) {
          set(this.threeMenu, `${this.threeMenu[key].redirect_from}.isClick`, true);
          this.$emit('open', this.threeMenu[key].redirect_from);
        }
      }
    });
    if (this.$route.matched.length >= 2) {
      this.isClickMenu = true;
    }
  },
  methods: {
    // 处理含有三级菜单的二级菜单（新元数据列表）点击后，不高亮问题
    handleMenuStyle(child) {
      if (child.children.length) {
        Object.keys(this.threeMenu).forEach((key) => {
          this.threeMenu[key].isClick = key === child.path;
        });
      }
      this.isClickMenu = child.children.length;
    },
    getRouterLink(name) {
      const routerList = this.$router.options.routes;
      for (let i = 0; i < routerList.length; i++) {
        const router = routerList[i];
        if (router.name === name) {
          return router.path;
        }
      }
    },
    condition(menu) {
      const isReg = this.routeList.includes(menu.path) || this.routeList.includes(menu.code);
      return menu.display === 1 && isReg;
    },
  },
};
